import { handleError } from "core/utils/HandleError"
import { handleResponse } from "core/utils/HandleResponse"
import { AuthHttpClient } from "core/utils/HttpClient"

export function getGames(params: any) {
  return AuthHttpClient
    .get('/admin/game', { params })
    .then(handleResponse)
    .catch(handleError)
}

export function getGameById(gameId: string) {
  return AuthHttpClient
    .get(`/admin/game/${gameId}`)
    .then(handleResponse)
    .catch(handleError)
}

export function addGame(gameData: any) {
  return AuthHttpClient
    .post('/admin/game', gameData)
    .then(handleResponse)
    .catch(handleError)
}

export function updateGame(gameData: any) {
  return AuthHttpClient
    .put('/admin/game', gameData)
    .then(handleResponse)
    .catch(handleError)
}

export function deleteGame(gameId: number) {
  return AuthHttpClient
    .delete(`/admin/game/${gameId}`)
    .then(handleResponse)
    .catch(handleError)
}

export function getGamePlatform() {
  return AuthHttpClient
    .get('/admin/game/platform')
    .then(handleResponse)
    .catch(handleError)
}

export function getGameCategory() {
  return AuthHttpClient
    .get('/admin/game/category')
    .then(handleResponse)
    .catch(handleError)
}

export function getGameType() {
  return AuthHttpClient
    .get('/admin/game/type')
    .then(handleResponse)
    .catch(handleError)
}
